<template>
  <div id="tbe-main-view" class="tbe-main-view">
    <a class="tbe-block tbe-mb-2" href="javascript:void(0)" @click="handleClickBack">
      &lt;&lt; Change date, time or option
    </a>
    <tbe-pre-order-details class="tbe-mb-4" />

    <div :style="{ position: 'relative' }">
      <tbe-contact-details-form ref="form" :busy="busy" />

      <tbe-loading
        v-model:active="busy"
        :is-full-page="false"
        color="#1976d2"
        :opacity="0.6"
        transition="tbe-loader-fade"
      >
        <tbe-ball-grid-pulse />
      </tbe-loading>
    </div>

    <tbe-button
      id="rs-order-continue--step-submit"
      variant="primary"
      :loading="busy"
      :disabled="busy"
      data-cy="rs-order-continue--step-submit"
      @click="handleClickContinue"
    >
      {{ !busy ? t('Global.Continue') : `${t('Global.Loading')}...` }}
    </tbe-button>
  </div>
</template>

<script>
  import { computed, onMounted, ref } from 'vue'
  import { useStore } from 'vuex'
  import { useI18n } from 'vue-i18n'
  import tbeLoading from 'vue-loading-overlay'

  import { loaders, RsButton as tbeButton } from 'common/components'

  import tbePreOrderDetails from '@/components/tbePreOrderDetails'
  import tbeContactDetailsForm from '@/components/tbeContactDetailsForm'

  import useDataLayer, { DATA_LAYER_EVENTS } from '@/hooks/useDataLayer'

  import { VIEWS } from '@/config'
  import BookingService from '@/services/booking.service'

  export default {
    name: 'tbeOrderView',

    components: {
      tbePreOrderDetails,
      tbeContactDetailsForm,
      tbeButton,
      tbeLoading,
      tbeBallGridPulse: loaders.RsBallGridPulse
    },

    setup() {
      const store = useStore()
      const { t } = useI18n()
      const dataLayer = useDataLayer()

      const form = ref()
      const busy = ref(false)

      const setView = (payload) => store.dispatch('app/setView', payload)
      const handleClickBack = () => {
        setView(VIEWS.MAIN)
        clearOrder()
      }

      const generalSettings = computed(() => store.state.app.generalSettings)

      const customer = computed(() => store.state.booking.customer)
      const order = computed(() => store.state.booking.order)
      const updateOrder = (payload) => store.dispatch('booking/updateOrder', payload)
      const clearOrder = () => store.dispatch('booking/clearOrder')

      onMounted(() => {
        console.log(document.getElementById('tbe-main-view'))
        setTimeout(
          () =>
            document.getElementById('tbe-main-view').scrollIntoView({
              block: 'center',
              behavior: 'smooth'
            }),
          200
        )
      })

      const handleClickContinue = async () => {
        busy.value = true
        const success = await form.value.v.$validate()

        if (!success) {
          busy.value = false
          return
        }

        try {
          const { currency } = generalSettings.value

          const data = {
            customer: customer.value,
            order: { ...order.value, service_price_currency: currency.value }
          }

          const { booking_id: orderId } = await BookingService.sendOrder(data)

          await updateOrder({ id: orderId })
          await setView(VIEWS.FINAL_ORDER)

          dataLayer.clearEcommerce()
          dataLayer.pushEcommerce(DATA_LAYER_EVENTS.ECOMMERCE.PURCHASE)
        } catch (e) {
          console.log(e)
        } finally {
          busy.value = false
        }
      }

      return { t, form, busy, handleClickBack, handleClickContinue }
    }
  }
</script>

<style lang="scss" scoped>
  .tbe-main-view {
    > a {
      color: var(--rs-accent-color);
      text-decoration: underline;
    }
  }
</style>
